import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import SupportPage from './pages/SupportPage';
import Lightbox from './components/Lightbox';
import './styles/global.css';

function App() {
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxCaption, setLightboxCaption] = useState('');
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const openLightbox = (imageSrc, caption) => {
    setLightboxImage(imageSrc);
    setLightboxCaption(caption);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    setLightboxCaption('');
    document.body.style.overflow = '';
  };

  return (
    <div className="app">
      <Navigation />
      {/* CRITICAL: This spacer prevents content from hiding under fixed nav */}
      <div className="header-spacer"></div>
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage openLightbox={openLightbox} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/gallery" element={<GalleryPage openLightbox={openLightbox} />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/support" element={<SupportPage />} />
        </Routes>
      </main>
      <Footer />
      <Lightbox 
        image={lightboxImage} 
        caption={lightboxCaption} 
        onClose={closeLightbox} 
      />
    </div>
  );
}

export default App;